/**
 * Application-level constants for use across the application
 */

import ENVIRONMENT_VARIABLES from './environmentVariables';

/**
 * Label used for the first generation program predecessor option.
 * Displayed in Program Predecessor dropdowns across bulk edit and RPN detail views.
 */
export const FIRST_GENERATION_LABEL = '<1st Generation>';

// LDAP Group constants
const DEVELOPER_LDAP_GROUP_PROD = 'verity-dev';
const DEVELOPER_LDAP_GROUP_NON_PROD = 'verity-dev-non-prod';

/**
 * LDAP Groups configuration
 * DEVELOPER group varies based on environment stage (prod vs non-prod)
 */
export const LDAP_GROUPS = {
  DEVELOPER: ENVIRONMENT_VARIABLES.env.Stage === 'prod' ? DEVELOPER_LDAP_GROUP_PROD : DEVELOPER_LDAP_GROUP_NON_PROD,
  READ_ONLY: 'verity-read-only',
} as const;

// Public view username
export const PUBLIC_VIEW_USERNAME = 'PUBLIC';

// Application branding
export const APP_NAME = 'Verity';
export const APP_DESCRIPTION = 'Das Fintech Verity Website';

export const PHONE_TOOL_URL = 'https://phonetool.amazon.com/users/';
export const USER_IMG_BASE_URL = 'https://badgephotos.corp.amazon.com/?fullsizeimage=1&uid=';
export const PERMISSIONS_TOOL_URL = 'https://permissions.amazon.com/a/team/';

// External team application URLs
export const EXTERNAL_APP_URLS = {
  TOWNSEND_PART_DETAIL: 'https://devices.plm.aws.com/townsend/part/detail/',
};

/**
 * Ticket-related external links (t.corp.amazon.com, sim.amazon.com)
 */
export const TICKET_LINKS = {
  VERITY_SUPPORT: {
    text: 'Verity support',
    href: 'https://t.corp.amazon.com/create/templates/003d9edb-b0eb-4d5f-82f6-2abaebf391a7',
  },
  FEATURE_REQUEST: {
    text: 'Feature Request',
    href: 'https://form.asana.com/?k=JSROdvXhiLc0vIc9cG9-xw&d=8442528107068',
  },
  UPDATE_PROGRAM_PPLS: {
    text: 'Update program in PPLS',
    href: 'https://sim.amazon.com/issues/create?template=7aeb673c-8deb-4131-9c95-ed573da17067',
  },
} as const;

/**
 * Communication channels
 */
export const COMMUNICATION_LINKS = {
  SLACK_CHANNEL: {
    text: '#verity-users',
    href: 'https://app.slack.com/client/E015GUGD2V6/C0AEUU19FCZ',
  },
} as const;

/**
 * Other external links (documentation, wikis, etc.)
 */
export const OTHER_EXTERNAL_LINKS = {
  DOCUMENTATION_WIKI: {
    text: 'Verity Wiki',
    href: 'https://w.amazon.com/bin/view/DaS-FinTech/Products/Verity2/',
  },
  SIM_TICKET: {
    text: 'SIM Ticket',
    href: 'https://t.corp.amazon.com/create/templates/003d9edb-b0eb-4d5f-82f6-2abaebf391a7',
  },
} as const;
